export type TNativeAudioWorklet = AudioWorklet;
